import { Directive, ElementRef, ViewChild } from "@angular/core";


@Directive()
export abstract class AbstractTooltipable {

  @ViewChild('tooltip', {read: ElementRef})
    tooltipElement!: ElementRef<HTMLElement>;

  private containerRelativeTo: HTMLElement | undefined = undefined;
  private lastMousemoveTimestamp: number = -1;
  private mousemoveEventInterval: number = 100;
  

  public constructor(containerRelativeTo: HTMLElement | undefined = undefined) {
    this.containerRelativeTo = containerRelativeTo;
  }
  
  public hideTooltip(): void {
    if (this.tooltipElement) {
      this.tooltipElement.nativeElement.classList.remove('visible');
    }
  }

  public showTooltip(event: any, text: string): void {
    if (this.tooltipElement) {
      let now = new Date().getTime();
      if (this.mousemoveEventInterval >= 0 &&
          now - this.lastMousemoveTimestamp > this.mousemoveEventInterval) {
        this.tooltipElement.nativeElement.innerHTML = text;

        if (this.containerRelativeTo) {
          let containerRect = this.containerRelativeTo.getBoundingClientRect();
          this.tooltipElement.nativeElement.style.left = event.pageX - containerRect.left + 15 + 'px';
          this.tooltipElement.nativeElement.style.right = 'auto';
          this.tooltipElement.nativeElement.style.top = event.pageY - containerRect.top + 15 + 'px';
          this.tooltipElement.nativeElement.style.bottom = 'auto';
        } else {
          // If tooltip is too close to the right or bottom edge of the window, move it to the left or top
          if (event.pageX + 400 > window.innerWidth + window.scrollX) {
            this.tooltipElement.nativeElement.style.right = (window.innerWidth) - event.pageX - 15 + 'px';
            this.tooltipElement.nativeElement.style.left = 'auto';
          } else {
            this.tooltipElement.nativeElement.style.left = event.pageX + 15 + 'px';
            this.tooltipElement.nativeElement.style.right = 'auto';
          }
          if (event.pageY + 200 > window.innerHeight + window.scrollY) {
            this.tooltipElement.nativeElement.style.bottom = (window.innerHeight) - event.pageY + 'px';
            this.tooltipElement.nativeElement.style.top = 'auto';
          } else {
            this.tooltipElement.nativeElement.style.top = event.pageY + 15 + 'px';
            this.tooltipElement.nativeElement.style.bottom = 'auto';
          }
        }

        this.tooltipElement.nativeElement.classList.add('visible');
        this.lastMousemoveTimestamp = now;
      }
    }
  }
}